import React, { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import type { LinkProps as RouterLinkProps } from 'react-router-dom';

import { Button } from './Button';
import type { ButtonProps } from './Button';

const RouterHref = forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'> & { href: string }>(function RouterHref(
  { href, ...rest },
  ref,
) {
  return <RouterLink ref={ref} to={href} {...rest} />;
});

export type ButtonLinkProps = Omit<ButtonProps, 'href' | 'onClick' | 'type' | 'LinkComponent'> & { readonly to: string; readonly state?: unknown };

export const ButtonLink: React.FC<ButtonLinkProps> = ({ to, state, ...button }) => {
  const linkState: Pick<RouterLinkProps, 'state'> = state === undefined ? {} : { state };
  return <Button {...button} {...linkState} href={to} LinkComponent={RouterHref} />;
};
